import { useGetAccount } from "@/api/account/account"
import { useGetAccountId } from "@/lib/useGetAccountId"
import { computed } from "vue"

import { describeMoveOut } from "@/views/myaccount/moving-home/movingHomeState"

export const useMoveOutSummary = () => {
  const { accountId } = useGetAccountId()
  const accountQuery = useGetAccount(accountId)

  return computed(() =>
    describeMoveOut(accountQuery.data.value?.supplyAddress?.addressLine1),
  )
}
